import CartPreviewIcon from './CartPreviewIcon';

export default CartPreviewIcon;
